<template>
  <div class="container-type">
    <containerType
      :parent-type="containerDetail.type"
      :container-index="containerIndex"
      :last-index="lastIndex"
    />
    <containerQuantity
      :quantity="containerDetail.quantity"
      :container-index="containerIndex"
      :last-index="lastIndex"
      :has-customer-specific-billing="hasCustomerSpecificBilling"
    />
    <div
      v-if="!firstIndex"
      class="col mr-1 position-relative"
    >
      <div
        class="container-minus-button mt-3"
      >
        <img
          @click.prevent="removeContainer()"
          class="cursor-pointer"
          src="src/assets/images/minus.png"
          alt="minus"
        >
      </div>
    </div>
  </div>
</template>
<script>
import containerQuantity from './containerQuantity.vue';
import containerType from './containerType.vue';

export default {
  name: 'ContainerBuilder',
  components: { containerQuantity, containerType },
  methods: {
    removeContainer() {
      this.$store.commit('container/resetContainerIndex', { typeID: this.containerDetail.type.id });
      this.$store.dispatch('container/removeContainerAction', this.containerIndex);
      this.$store.commit('container/triggerReOrderContainerIndex', this.containerIndex);
    },
  },
  props: {
    containerDetail: {
      type: Object,
      default: () => ({
        type: {
          id: '',
          container_type: '',
        },
        quantity: 0,
      }),
    },
    lastIndex: {
      type: Boolean,
      default: false,
    },
    firstIndex: {
      type: Boolean,
      default: false,
    },
    containerIndex: {
      type: Number,
      default: 0,
    },
    hasCustomerSpecificBilling: {
      default: false,
      type: Boolean,
    },
  },
};
</script>
